export default "__VITE_ASSET__6384e929__"